import { useMemo } from "react";

import { type ResourceConfig, ResourcePage, fmtDate } from "@/components/resource-page";
import type { Translate } from "@/constants/i18n";
import { useTranslation } from "@/store/locale";

interface Category {
  id: number;
  name: string;
  created_by_id: number | null;
  created_at: string;
}

const build = (t: Translate): ResourceConfig<Category> => ({
  title: t("page.yellowPageCategories"),
  singular: t("ypc.category"),
  endpoint: "/yellow-page-categories",
  backTo: "/yellow-page",
  defaultSort: { key: "name", order: "asc" },
  columns: [
    { key: "id", label: t("rp.id"), sortKey: "id", render: (row) => row.id },
    { key: "name", label: t("geo.name"), sortKey: "name", render: (row) => row.name },
    {
      key: "created_by",
      label: t("geo.createdBy"),
      render: (row, lookup) => lookup("created_by_id", row.created_by_id),
    },
    {
      key: "created_at",
      label: t("geo.createdAt"),
      sortKey: "created_at",
      render: (row) => fmtDate(row.created_at),
    },
  ],
  // The lookup for Created By rides on this filter's options, even hidden.
  filters: [
    {
      name: "created_by_id",
      label: t("geo.createdByFilter"),
      type: "fk",
      endpoint: "/users/compact",
    },
  ],
  fields: [{ name: "name", label: t("geo.name"), required: true }],
  toForm: (row) => ({ name: row.name }),
});

function CategoriesPage() {
  const t = useTranslation();
  const config = useMemo(() => build(t), [t]);
  return <ResourcePage config={config} />;
}

export default CategoriesPage;
